module.exports = "/shifts/components/unavailabilityConfirmationModal-7851c5.html";